import { bool, func, number, string } from "prop-types";
import { BreakdownTableDepths } from "@repo/utils";
import { capitalize, Grid, IconButton, Switch, Tooltip } from "@material-ui/core";
import { Tag, TextClearInput } from "@components";
import { useMemo, useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Trash } from "@assets";

export const BufferTitle = ({
  name,
  lvl,
  used,
  expanded,
  percent,
  setUsed,
  setName,
  onNameInputFocus,
  onRemove,
  useActions=true,
  readOnly,
}) => {
  const { t } = useTranslation();
  
  const [inputValue, setInputValue] = useState(name);
  const [focused, setFocused] = useState(false);
  
  const elementType = useMemo(() => (
    t(`proposal_parts.module_levels.level_${lvl}`)
  ), [lvl]);
  
  const handleFocus = () => {
    if(onNameInputFocus) {
      onNameInputFocus();
      return;
    }
    setFocused(true);
  }
  
  const handleSetName = () => {
    setFocused(false);
    if(!inputValue?.length)
      setInputValue(name);
    else
      setName(inputValue);
  }
  
  const handleSetUsed = (e) => {
    e.stopPropagation();
    setUsed?.(!used)
  }
  
  return (
    <Grid
      item container
      justifyContent="space-between"
      alignItems="center"
      wrap="nowrap"
    >
      <Grid
        item container
        alignItems="center"
        wrap="nowrap"
        className="w-full"
        // style={{ maxWidth: 380 }}
      >
        <TextClearInput
          multiline
          value={inputValue}
          focused={focused}
          onFocus={handleFocus}
          onChange={setInputValue}
          onAccept={handleSetName}
          acceptOnClickAway
          confirmOnEnter
          error={!inputValue?.length}
          placeholder={t("views.editor.dialogs.buffers.name_placeholder")}
          containerClass="name"
          className={classnames("mx-2 my-1")}
          maxLength={120}
        />
        {
          !expanded && typeof percent === "number" &&
          <span className="text-sm font-bold transparent-2">
            { `(${ percent }%)` }
          </span>
        }
        {
          lvl >= BreakdownTableDepths.SECTION &&
          <Tooltip title={t("views.editor.dialogs.buffers.item_tooltip", { elementType })}>
            <span>
              <Tag
                text={capitalize(elementType)}
                className="ml-1"
              />
            </span>
          </Tooltip>
        }
      </Grid>
      {
        useActions &&
        <Grid
          item container
          alignItems="center"
          className="w-max"
          style={{ minWidth: 84 }}
        >
          {
            Boolean(onRemove) &&
            <IconButton
              onClick={onRemove}
              size="small"
              className={classnames("hoverIcon mr-2", readOnly && "transparent-2")}
            >
              <Trash color="error" />
            </IconButton>
          }
          <Switch
            color="primary"
            checked={used}
            onChange={handleSetUsed}
          />
        </Grid>
      }
    </Grid>
  );
};

BufferTitle.propTypes = {
  used: bool.isRequired,
  name: string.isRequired,
  lvl: number,
  percent: number,
  setUsed: func,
  setName: func.isRequired,
  onRemove: func,
  onNameInputFocus: func,
  useActions: bool,
  expanded: bool,
  readOnly: bool,
};